import SettingsTabs from './SettingsTabs';

export default SettingsTabs;
